module.exports = __webpack_public_path__ + "img/operators1.7ea63559.png";